export default __webpack_public_path__ + "static/media/3.c829aba7.png";